import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { ELandStatusType } from '../../../../../../../json_query';
import { changeLandStatus } from '../../../../../../state/advanced/land_status';

import { LandStatus as LandStatusComponent, ILandStatusProps } from './landStatus';

type TLandStatusStateProps = Pick<ILandStatusProps, 'value'>;
type TLandStatusDispatchProps = Pick<ILandStatusProps, 'onChange'>;

export function mapStateToProps(state: IAppState): TLandStatusStateProps {
  return {
    value: (state.filters.jsonQuery.land_status && state.filters.jsonQuery.land_status.value) || [],
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TLandStatusDispatchProps {
  return {
    onChange: (status: ELandStatusType, value: boolean) => {
      dispatch(changeLandStatus(status, value));
    },
  };
}

export const LandStatus = connect(mapStateToProps, mapDispatchToProps)(LandStatusComponent);
